export type PlanFeature = { text: string; value?: string; href?: string };

export const pricingPlans = [
    {
        name: "Monthly",
        price: "37",
        period: "/month",
        description: "Get started with essentials",
        ctaLabel: "Start building",
        priceId: "price_1RGD0OLgTWa1LJDriSm1AJ2f", // test price_1RDn65LgTWa1LJDrMb69irIu
        skoolPriceId: "price_1RGAq8LgTWa1LJDrewTixyVL", // Skool special price
        legacyPriceId: "price_1RIN1qLgTWa1LJDrntwmsdQW", // Legacy price ID
        productId: "prod_SAY663G4xOqtxG", // test prod_S83CKwXI8zrDod
        skoolProductId: "prod_SAVrsblJe9hW6P", // Skool special product
        legacyProductId: "prod_SCmb6l2JRswLEt", // Legacy product ID
        //! Payment links deprecated, use checkout route instead
        paymentLink: "https://buy.stripe.com/28o5kP6xNaARcLK9AH", //! test https://buy.stripe.com/test_8wMfZc4LVaM3fGUaEE
        skoolPaymentLink: "https://buy.stripe.com/6oE5kPbS79wN1325kv?prefilled_promo_code=SKOOLMONTHLY", //! Skool special link 
        legacyPaymentLink: "https://buy.stripe.com/aEUdRlg8ngZf9zy5kx?prefilled_promo_code=SKOOLLEGACYMONTHLY", //! Legacy link
        //! Payment links deprecated, use checkout route instead
        skoolPromoId: "promo_1RIco0LgTWa1LJDr7q7NmLCw",
        legacyPromoId: "promo_1RIcjHLgTWa1LJDrI7JQl4xd",
        features: [
            { text: "AI builder community access + weekly live workshop", value: "$348" },
            { text: "Unlimited access to courses", value: "$1,200", href: "/courses" },
            { text: "Full code/prompt examples for building AI apps", value: "$500" },
            { text: "SaaS Launch Kit & MCP boilerplates & Claude Code Template", value: "$800" },
            { text: "10xCoder.dev access", value: "$480" },
            { text: "Exclusive Builder pack", value: "$300" }
        ] as PlanFeature[]
    },
    {
        name: "Yearly",
        price: "289",
        period: "/year",
        description: "Save $155 compared to monthly.",
        subtext: "That's just $24/month!",
        ctaLabel: "Get instant access",
        featuresIntro: "Everything in Monthly, plus:",
        valueTotal: 3828,
        priceId: "price_1RGD5NLgTWa1LJDrFKbublRV", // test price_1RDn6iLgTWa1LJDr6bjS3eu9
        skoolPriceId: "price_1RGAqRLgTWa1LJDrltOW3KQj", // Skool special price
        legacyPriceId: "price_1RJCS0LgTWa1LJDriQtzIiA9", // Legacy price ID
        productId: "prod_SAYBxFpflhKuy9", // test prod_S83CKwXI8zrDod
        skoolProductId: "prod_SAVsOXGnVFrZXU",// Skool special product
        legacyProductId: "prod_SCmbbqw8kvgmSO", // Legacy product ID
        //! Payment links deprecated, use checkout route instead
        paymentLink: "https://buy.stripe.com/28odRl2hx5gx4fe9AJ", //! test https://buy.stripe.com/test_6oE9AOcen2fx66k6op
        skoolPaymentLink: "https://buy.stripe.com/bIY4gL3lB5gxcLKaEO?prefilled_promo_code=SKOOLANNUAL", //! Skool special link
        legacyPaymentLink: "https://buy.stripe.com/28odRlcWb38peTSeV8?prefilled_promo_code=SKOOLLEGACYANNUAL", //! Legacy link
        //! Payment links deprecated, use checkout route instead
        skoolPromoId: "promo_1RIcnWLgTWa1LJDrPvgOaXeO",
        legacyPromoId: "promo_1RIciCLgTWa1LJDrO1x6RuWA",
        features: [
            { text: "Save 35%, only $0.8 per day" },
            { text: "1:1 mentorship session" },
            { text: "Priority tech support" },
            { text: "Early access to new tools & content" }
        ] as PlanFeature[],
        popular: true
    }
]


export const accessGroups = [
    {
        "id": 16455,
        "name": "New free members",
    },
    {
        "id": 20315,
        "name": "Monthly member",
    },
    {
        "id": 20317,
        "name": "Yearly member",
    }
]

export const spaces = [
    {
        "id": 1942514,
        "name": "1:1 call with Jason",
        "slug": "test",
        "space_group_name": "AI Builder Community",
        "space_group_id": 728065,
        "url": "https://aibuilderclub.circle.so/c/test",
        "is_private": true
    },
    {
        "id": 1942767,
        "name": "Tips & Source codes",
        "slug": "tips-source-codes",
        "space_group_name": "Classroom",
        "space_group_id": 728036,
        "url": "https://aibuilderclub.circle.so/c/tips-source-codes",
        "is_private": true
    },
    {
        "id": 1942764,
        "name": "Sass Launch kit",
        "slug": "sass-launch-kit",
        "space_group_name": "Premium tools",
        "space_group_id": 728155,
        "url": "https://aibuilderclub.circle.so/c/sass-launch-kit",
        "is_private": true
    },
    {
        "id": 1942763,
        "name": "10xCoder.dev",
        "slug": "10xcoder-dev",
        "space_group_name": "Premium tools",
        "space_group_id": 728155,
        "url": "https://aibuilderclub.circle.so/c/10xcoder-dev",
        "is_private": true
    },
    {
        "id": 1942758,
        "name": "Finetune",
        "slug": "finetune",
        "space_group_name": "Classroom",
        "space_group_id": 728036,
        "url": "https://aibuilderclub.circle.so/c/finetune",
        "is_private": false
    },
    {
        "id": 1942750,
        "name": "Build production LLM apps",
        "slug": "build-production-llm-apps",
        "space_group_name": "Classroom",
        "space_group_id": 728036,
        "url": "https://aibuilderclub.circle.so/c/build-production-llm-apps",
        "is_private": false
    },
    {
        "id": 1942733,
        "name": "100X Cursor Workflow",
        "slug": "how-to-write-cursor-docs-8e16ce",
        "space_group_name": "Classroom",
        "space_group_id": 728036,
        "url": "https://aibuilderclub.circle.so/c/how-to-write-cursor-docs-8e16ce",
        "is_private": false
    },
    {
        "id": 1942580,
        "name": "Agent crash course",
        "slug": "build-ios-app-ai-coding",
        "space_group_name": "Classroom",
        "space_group_id": 728036,
        "url": "https://aibuilderclub.circle.so/c/build-ios-app-ai-coding",
        "is_private": false
    },
    {
        "id": 1942570,
        "name": "Cursor prompt templates",
        "slug": "how-to-write-cursor-docs",
        "space_group_name": "Classroom",
        "space_group_id": 728036,
        "url": "https://aibuilderclub.circle.so/c/how-to-write-cursor-docs",
        "is_private": true
    },
    {
        "id": 1942566,
        "name": "Expert-talk",
        "slug": "expert-talk",
        "space_group_name": "Classroom",
        "space_group_id": 728036,
        "url": "https://aibuilderclub.circle.so/c/expert-talk",
        "is_private": true
    },
    {
        "id": 1942563,
        "name": "Ask for help",
        "slug": "ask-for-help",
        "space_group_name": "AI Builder Community",
        "space_group_id": 728065,
        "url": "https://aibuilderclub.circle.so/c/ask-for-help",
        "is_private": true
    },
    {
        "id": 1942561,
        "name": "Community posts",
        "slug": "community-posts",
        "space_group_name": "AI Builder Community",
        "space_group_id": 728065,
        "url": "https://aibuilderclub.circle.so/c/community-posts",
        "is_private": true
    },
    {
        "id": 1942556,
        "name": "Coding 101 for Beginners",
        "slug": "ai-coding-masterclass",
        "space_group_name": "Classroom",
        "space_group_id": 728036,
        "url": "https://aibuilderclub.circle.so/c/ai-coding-masterclass",
        "is_private": true
    },
    {
        "id": 1942529,
        "name": "General chat",
        "slug": "chat",
        "space_group_name": "AI Builder Community",
        "space_group_id": 728065,
        "url": "https://aibuilderclub.circle.so/c/chat",
        "is_private": true
    },
    {
        "id": 1942491,
        "name": "AI Builder Pack",
        "slug": "resources",
        "space_group_name": "AI Builder Community",
        "space_group_id": 728065,
        "url": "https://aibuilderclub.circle.so/c/resources",
        "is_private": true
    },
    {
        "id": 1942490,
        "name": "Say Hello",
        "slug": "say-hello",
        "space_group_name": "Get Started",
        "space_group_id": 728037,
        "url": "https://aibuilderclub.circle.so/c/say-hello",
        "is_private": false
    },
    {
        "id": 1942489,
        "name": "Start Here",
        "slug": "start-here",
        "space_group_name": "Get Started",
        "space_group_id": 728037,
        "url": "https://aibuilderclub.circle.so/c/start-here",
        "is_private": false
    }
]

// todo monthly and yearly 
